import React from "react";
import { useEffect, useState } from "react";
import {
  CompanyManageGetAutoAvrageRate,
  CompanyManageGetAutoStock,
  CompanyManageMyCompany,
  CompanyManageMyStore,
  CompetitorPackeageFilterCompanyPackeageBy,
} from "../../Api/Services";
import InputCus from "../../Component/InputCus/Text/InputCus";
import { toast } from "react-toastify";

function ShowMarketBy() {
  const [isLoading, setLoading] = useState(true);
  const [Company, setCompany] = useState([]);
  const [Data, setData] = useState();
  const [CompanyId, setCompanyId] = useState();
  const [CompetitorId, SetCompetitorId] = useState([]);
  const [Competitor, SetCompetitor] = useState([]);
  const [Package, SetPackage] = useState([]);
  const [Product, setProduct] = useState("");

  const start = async () => {
    setCompany([]);
    setCompanyId();
    try {
      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        for (const item of CompanyManageMyStoreData.data.data) {
          const CompanyManageGetAutoAvrageRateData =
            await CompanyManageGetAutoAvrageRate(item.companyStoreId);
          if (
            CompanyManageGetAutoAvrageRateData.status &&
            CompanyManageGetAutoAvrageRateData.status === 200
          ) {
            if (CompanyManageGetAutoAvrageRateData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای نرخ میانگین برقرار شد
                ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
          const CompanyManageGetAutoStockData = await CompanyManageGetAutoStock(
            item.companyStoreId,
          );
          if (
            CompanyManageGetAutoStockData.status &&
            CompanyManageGetAutoStockData.status === 200
          ) {
            if (CompanyManageGetAutoStockData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای موجودی برقرار شد
                ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
        }
      }

      const CompanyManageMyCompanysData = await CompanyManageMyCompany();
      if (
        CompanyManageMyCompanysData.status &&
        CompanyManageMyCompanysData.status === 200
      ) {
        if (CompanyManageMyCompanysData.data.data.length > 0) {
          await SetCompanyClick(
            CompanyManageMyCompanysData.data.data[0].companyId,
          );
        }
        setCompany(CompanyManageMyCompanysData.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const SetCompanyClick = async (id) => {
    setCompanyId(id);
    setLoading(true);
    try {
      const CompetitorPackeageFilterCompanyPackeageByData =
        await CompetitorPackeageFilterCompanyPackeageBy(id);
      if (
        CompetitorPackeageFilterCompanyPackeageByData.status &&
        CompetitorPackeageFilterCompanyPackeageByData.status === 200
      ) {
        setData(CompetitorPackeageFilterCompanyPackeageByData.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const GetAverageRate = (item) => {
    const data = Data.getBaseData;

    const products = data.filter(
      (p) =>
        p.productBerandId == item.productBerandId &&
        p.productTypeId == item.productTypeId &&
        p.productSeriesId == item.productSeriesId &&
        p.symbol == item.symbol &&
        p.productSeriesEndId == item.productSeriesEndId &&
        p.productRamId == item.productRamId &&
        p.productRomId == item.productRomId &&
        p.productNetworkId == item.productNetworkId &&
        p.productCountryId == item.productCountryId &&
        p.isInsurance == item.isInsurance,
    );
    let avrage = products.flatMap((w) => w.avrageRate);
    let stock = products.flatMap((w) => w.stock);

    let sumAvrage = 0;
    avrage
      .filter((e) => e.price > 0)
      .forEach((element) => {
        let a =
          element.price *
          stock.find(
            (w) =>
              w.companyStoreId == element.companyStoreId &&
              w.productId == element.productId,
          )?.stock;

        sumAvrage = sumAvrage + a;
      });
    const avg = sumAvrage / stock.reduce((sum, x) => sum + x.stock, 0);
    return (
      <>
        {avg ? (
          <td>
            {Math.trunc(avg)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </td>
        ) : (
          <td>-</td>
        )}
      </>
    );
  };

  const GetPriceComAvrage = (item, id) => {
    const data = Data.getBaseData;

    const products = data.filter(
      (p) =>
        p.productBerandId == item.productBerandId &&
        p.productTypeId == item.productTypeId &&
        p.productSeriesId == item.productSeriesId &&
        p.symbol == item.symbol &&
        p.productSeriesEndId == item.productSeriesEndId &&
        p.productRamId == item.productRamId &&
        p.productRomId == item.productRomId &&
        p.productNetworkId == item.productNetworkId &&
        p.productCountryId == item.productCountryId &&
        p.isInsurance == item.isInsurance,
    );
    let avrage = products
      .flatMap((w) => w.competitorPrices)
      .filter((w) => w.competitorId == id);

    const avgPrice =
      avrage.reduce((sum, item) => sum + item.price, 0) / avrage.length;

    return (
      <>
        <td className={`pointer ${CompetitorId.includes(id) && "bg-warning"}`}>
          {avgPrice
            ? Math.trunc(avgPrice)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "-"}
        </td>
      </>
    );
  };

  const GetPriceCatAvrage = (item, id) => {
    const data = Data.getBaseData;

    const products = data.filter(
      (p) =>
        p.productBerandId == item.productBerandId &&
        p.productTypeId == item.productTypeId &&
        p.productSeriesId == item.productSeriesId &&
        p.symbol == item.symbol &&
        p.productSeriesEndId == item.productSeriesEndId &&
        p.productRamId == item.productRamId &&
        p.productRomId == item.productRomId &&
        p.productNetworkId == item.productNetworkId &&
        p.productCountryId == item.productCountryId &&
        p.isInsurance == item.isInsurance,
    );
    let avrage = products
      .flatMap((w) => w.avrageCompeti)
      .filter((w) => w.categoryId == id);

    const avgPrice =
      avrage.reduce((sum, item) => sum + item.price, 0) / avrage.length;

    return (
      <>
        <td>
          {avgPrice
            ? Math.trunc(avgPrice)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "-"}
        </td>
      </>
    );
  };

  const GetStock = (item) => {
    const data = Data.getBaseData;

    const products = data.filter(
      (p) =>
        p.productBerandId == item.productBerandId &&
        p.productTypeId == item.productTypeId &&
        p.productSeriesId == item.productSeriesId &&
        p.symbol == item.symbol &&
        p.productSeriesEndId == item.productSeriesEndId &&
        p.productRamId == item.productRamId &&
        p.productRomId == item.productRomId &&
        p.productNetworkId == item.productNetworkId &&
        p.productCountryId == item.productCountryId &&
        p.isInsurance == item.isInsurance,
    );
    let stock = products.flatMap((w) => w.stock);
    const sum = stock.reduce((sum, x) => sum + x.stock, 0);
    return sum;
  };

  const ChangeActiveCompetitor = (id) => {
    let copy = [...Competitor];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetCompetitor(copy);
  };

  const ChangeActivePackage = (id) => {
    let copy = [...Package];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetPackage(copy);
  };

  const HandelCopitetor = (id) => {
    let copy = [...CompetitorId];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetCompetitorId(copy);
  };

  const HandelSodeProduct = (PackageId, pro) => {
    const data = Data.getBaseData;

    const relatedProducts = data.filter(
      (p) =>
        p.productBerandId == pro.productBerandId &&
        p.productTypeId == pro.productTypeId &&
        p.productSeriesId == pro.productSeriesId &&
        p.symbol == pro.symbol &&
        p.productSeriesEndId == pro.productSeriesEndId &&
        p.productRamId == pro.productRamId &&
        p.productRomId == pro.productRomId &&
        p.productNetworkId == pro.productNetworkId &&
        p.productCountryId == pro.productCountryId &&
        p.isInsurance == pro.isInsurance,
    );

    const pricesPerCompetitor = relatedProducts
      .flatMap((p) => p.competitorPrices)
      .filter((p) => CompetitorId.includes(p.competitorId))
      .map((p) => p.price);

    if (pricesPerCompetitor.length === 0) {
      return (
        <>
          <td>-</td>
          <td>-</td>
        </>
      );
    }

    const average =
      pricesPerCompetitor.reduce((sum, p) => sum + p, 0) /
      pricesPerCompetitor.length;

    const pak = pro.competitorPackagePrices.find(
      (w) => w.competitorPackageId == PackageId,
    );

    if (!pak) {
      return (
        <>
          <td>-</td>
          <td>-</td>
        </>
      );
    }

    const profit = (average - pak.price) * pak.count;
    const percent = ((average - pak.price) / pak.price) * 100;

    return (
      <>
        <td
          style={{ direction: "ltr" }}
          className={percent > 0 ? "Sabz" : "ghermez"}
        >
          {Math.round(percent)}%
        </td>
        <td
          style={{ direction: "ltr" }}
          className={profit > 0 ? "Sabz" : "ghermez"}
        >
          {Math.round(profit).toLocaleString()}
        </td>
      </>
    );
  };

  const PkgSode = (pkgId) => {
    const Prices = [];
    const data = Data.getBaseData;

    let totalBuyAsaaraa = [];
    [...data].map((w) => {
      if (
        w.competitorPackagePrices.some((r) => r.competitorPackageId == pkgId)
      ) {
        let aa = w.competitorPackagePrices.find(
          (r) => r.competitorPackageId == pkgId,
        );
        totalBuyAsaaraa.push(aa.count * aa.price);
      }
    });
    const totalBuyAsa = totalBuyAsaaraa.reduce((sum, item) => sum + item, 0);

    const productsWithPkg = data.filter((w) =>
      w.competitorPackagePrices.some((r) => r.competitorPackageId == pkgId),
    );

    productsWithPkg.forEach((elementPro) => {
      const pricesPerCompetitor = [];

      CompetitorId.forEach((competitorId) => {
        const relatedProducts = data.filter(
          (p) =>
            p.productBerandId == elementPro.productBerandId &&
            p.productTypeId == elementPro.productTypeId &&
            p.productSeriesId == elementPro.productSeriesId &&
            p.symbol == elementPro.symbol &&
            p.productSeriesEndId == elementPro.productSeriesEndId &&
            p.productRamId == elementPro.productRamId &&
            p.productRomId == elementPro.productRomId &&
            p.productNetworkId == elementPro.productNetworkId &&
            p.productCountryId == elementPro.productCountryId &&
            p.isInsurance == elementPro.isInsurance,
        );

        const prices = relatedProducts
          .flatMap((p) => p.competitorPrices)
          .filter((p) => p.competitorId === competitorId);

        prices.forEach((p) => {
          pricesPerCompetitor.push(p.price);
        });
      });

      if (pricesPerCompetitor.length > 0) {
        const avg =
          pricesPerCompetitor.reduce((sum, p) => sum + p, 0) /
          pricesPerCompetitor.length;

        const pak = elementPro.competitorPackagePrices.find(
          (w) => w.competitorPackageId == pkgId,
        );

        Prices.push({
          Buy: pak.price * pak.count,
          CountPrice: (avg - pak.price) * pak.count,
          Count: pak.count,
          Price: pak.price,
          MarPrice: avg,
        });
      }
    });

    if (Prices.length === 0) {
      return (
        <div className="d-flex justify-content-center flex-column">
          <span>مبلغ سبد :{Math.round(totalBuyAsa).toLocaleString()}</span>
        </div>
      );
    }

    const totalBuy = Prices.reduce((sum, p) => sum + p.Buy, 0);
    const totalProfit = Prices.reduce((sum, p) => sum + p.CountPrice, 0);
    const basketProfitPercent = (totalProfit / totalBuy) * 100;

    return (
      <div className="d-flex justify-content-center flex-column">
        <span>مبلغ سبد :{Math.round(totalBuyAsa).toLocaleString()}</span>
        <span>مبلغ سود :{Math.round(totalProfit).toLocaleString()}</span>
        <span>درصد سود : {Math.round(basketProfitPercent)}%</span>
      </div>
    );
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element">
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-1">
            <div className="d-flex justify-content-between align-items-center">
              {Company &&
                Company.map((item, key) => (
                  <button
                    onClick={() => {
                      SetCompanyClick(item.companyId);
                    }}
                    className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                      CompanyId == item.companyId ? "bg-warning" : ""
                    }`}
                  >
                    {item.companyName}
                  </button>
                ))}
            </div>
            {Data && (
              <div className="d-flex flex-column">
                {Data?.allCategory
                  .filter((w) => w.competitorCategoryCompetitors.length > 0)
                  .map((itemCategory) => (
                    <div className="d-flex align-item-center border rounded m-2 p-2 bg-info">
                      <div className="d-flex align-items-center">
                        <span> {itemCategory.competitorCategoryName}</span>
                      </div>
                      <div className="d-flex justify-align-center align-item-center flex-wrap">
                        {itemCategory.competitorCategoryCompetitors.map(
                          (item) => (
                            <div className="tooltip-container">
                              <div
                                className={`border rounded m-2 p-2 pointer ${
                                  Competitor.includes(item.id)
                                    ? "Actice"
                                    : "DeActice"
                                }`}
                                onClick={() => {
                                  ChangeActiveCompetitor(item.id);
                                }}
                              >
                                {item.name}
                              </div>
                              {item.description && (
                                <div
                                  className="tooltip-box p-3"
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}
                                />
                              )}
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            )}
            {Data && (
              <div className="d-flex flex-column">
                <div className="d-flex align-item-center border rounded m-2 p-2 bg-info">
                  <div className="d-flex align-items-center">
                    <span> سبد</span>
                  </div>
                  <div className="d-flex justify-align-center align-item-center flex-wrap">
                    {Data?.allPackeage.map((item) => (
                      <div
                        className={`border rounded m-2 p-2 pointer ${
                          Package.includes(item.id) ? "Actice" : "DeActice"
                        }`}
                        onClick={() => {
                          ChangeActivePackage(item.id);
                        }}
                      >
                        {item.competitorName}
                        {item.title != "" && "(" + item.title + ")"}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {CompanyId && (
              <div className="d-flex">
                <InputCus
                  className="m-2"
                  type="text"
                  name="name"
                  id="name"
                  text="نام"
                  value={Product}
                  onChange={(e) => {
                    setProduct(e.target.value);
                  }}
                />
              </div>
            )}
            {CompanyId && (
              <div>
                {Data && (
                  <div className="d-flex justify-content-center align-items-center w-100 tableC">
                    <table
                      className="table tableMore"
                      style={{ lineHeight: "normal" }}
                    >
                      <thead className="sticky-header">
                        <tr className="trTable">
                          <th rowSpan={3}>سیمبل کالای</th>
                          {Data.allPackeage
                            .filter((e) => Package.includes(e.id))
                            .map((cat, idx) => (
                              <th colSpan={4} key={idx}>
                                {cat.competitorName}
                                {cat.title != "" && "(" + cat.title + ")"}
                              </th>
                            ))}
                          <th rowSpan={3}>میانگین سبد ها</th>
                          <th rowSpan={3}>موجودی</th>
                          <th rowSpan={3}> نرخ میانگین انبار</th>
                          {Data.allCategory.map((cat, idx) => (
                            <th rowSpan={2}>{cat.competitorCategoryName}</th>
                          ))}
                          {Data.allCategory
                            .flatMap((e) => e.competitorCategoryCompetitors)
                            .filter((e) => Competitor.includes(e.id))
                            .map((cat, idx) => (
                              <th
                                rowSpan={2}
                                className={`pointer ${
                                  CompetitorId.includes(cat.id) && "bg-warning"
                                }`}
                                onClick={() => {
                                  HandelCopitetor(cat.id);
                                }}
                                key={idx}
                              >
                                {cat.name}
                              </th>
                            ))}
                        </tr>
                        {CompetitorId && (
                          <tr>
                            {Data.allPackeage
                              .filter((e) => Package.includes(e.id))
                              .map((cat, idx) => (
                                <th colSpan={4} key={idx}>
                                  {PkgSode(cat.id)}
                                </th>
                              ))}
                          </tr>
                        )}
                        <tr>
                          {Data.allPackeage
                            .filter((e) => Package.includes(e.id))
                            .map((cat, idx) => (
                              <React.Fragment key={cat.id}>
                                <th className="border border-1 border-black">
                                  قیمت
                                </th>
                                <th className=" border border-1 border-black">
                                  تعداد
                                </th>
                                <th className=" border border-1 border-black">
                                  درصد
                                </th>
                                <th className=" border border-1 border-black">
                                  میزان
                                </th>
                              </React.Fragment>
                            ))}
                          {Data.allCategory.map((cat, idx) => (
                            <th>میانگین قیمت</th>
                          ))}

                          {Data.allCategory
                            .flatMap((e) => e.competitorCategoryCompetitors)
                            .filter((e) => Competitor.includes(e.id))
                            .map((cat, idx) => (
                              <th
                                className={`pointer ${
                                  CompetitorId.includes(cat.id) && "bg-warning"
                                }`}
                                onClick={() => {
                                  HandelCopitetor(cat.id);
                                }}
                                key={idx}
                              >
                                میانگین قیمت
                              </th>
                            ))}
                        </tr>
                      </thead>
                      {Data.getBaseData
                        .filter((w) => {
                          const productFilter = Product?.toUpperCase?.() || "";

                          const Pro = [
                            w.productBerandName != " " &&
                              w.productBerandName + " ",

                            w.productTypeName != " " && w.productTypeName + " ",

                            w.productSeriesName != " " && w.productSeriesName,

                            w.symbol,

                            w.productSeriesEndName != " "
                              ? w.productSeriesEndName + " "
                              : " ",

                            w.productRamName != " " && w.productRamName + "/",

                            w.productRomName != " " && w.productRomName + " ",

                            w.productNetworkName != " " &&
                              w.productNetworkName + " ",

                            w.productCountryName != " " &&
                              w.productCountryName + " ",

                            w.isInsurance && "بیمه",
                          ]
                            .filter(Boolean)
                            .join("")
                            .toUpperCase();

                          return Pro.includes(productFilter);
                        })
                        .filter((w) => w.competitorPackagePrices.length > 0)
                        .map((itemPro, keyPro) => (
                          <tbody
                            style={{
                              border: "2px solid black",
                            }}
                          >
                            <tr key={keyPro}>
                              <td>
                                {itemPro.productBerandName != " " &&
                                  itemPro.productBerandName + " "}
                                {itemPro.productTypeName != " " &&
                                  itemPro.productTypeName + " "}
                                {itemPro.productSeriesName != " " &&
                                  itemPro.productSeriesName}
                                {itemPro.symbol}
                                {itemPro.productSeriesEndName != " "
                                  ? itemPro.productSeriesEndName + " "
                                  : " "}
                                {itemPro.productRamName != " " &&
                                  itemPro.productRamName + "/"}
                                {itemPro.productRomName != " " &&
                                  itemPro.productRomName + " "}
                                {itemPro.productNetworkName != " " &&
                                  itemPro.productNetworkName + " "}
                                {itemPro.productCountryName != " " &&
                                  itemPro.productCountryName + " "}
                                {itemPro.isInsurance && "بیمه"}{" "}
                              </td>
                              {Data.allPackeage
                                .filter((e) => Package.includes(e.id))
                                .map((cat, idx) => (
                                  <React.Fragment key={cat.id}>
                                    <td>
                                      {itemPro.competitorPackagePrices
                                        .find(
                                          (w) =>
                                            w.competitorPackageId == cat.id,
                                        )
                                        ?.price.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td>
                                      {
                                        itemPro.competitorPackagePrices.find(
                                          (w) =>
                                            w.competitorPackageId == cat.id,
                                        )?.count
                                      }
                                    </td>
                                    {HandelSodeProduct(cat.id, itemPro)}
                                  </React.Fragment>
                                ))}
                              <td>
                                {Math.round(itemPro.avrageVa)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>
                              <td>{GetStock(itemPro)}</td>
                              {GetAverageRate(itemPro)}

                              {Data.allCategory.map((cat, idx) =>
                                GetPriceCatAvrage(
                                  itemPro,
                                  cat.competitorCategoryId,
                                ),
                              )}

                              {Data.allCategory
                                .flatMap((e) => e.competitorCategoryCompetitors)
                                .filter((e) => Competitor.includes(e.id))
                                .map((cat, idx) => (
                                  <>{GetPriceComAvrage(itemPro, cat.id)}</>
                                ))}
                            </tr>
                          </tbody>
                        ))}
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ShowMarketBy;
